import React, { useState } from 'react';
import PostAddIcon from '@material-ui/icons/PostAdd';
import strings from 'strings';
import { FPIconButton, When } from 'UI/components/atoms';

import { DrawerTemplates } from '../DrawerTemplates';

const COPIES = strings.messageCenter.messageComposer.templates;

export const MessageTemplates = ({ disabled, onSelectTemplate }) => {
  const [openTemplates, setOpenTemplates] = useState(false);

  const toggleTemplates = () => {
    setOpenTemplates(prev => !prev);
  };

  const handleSelectTemplate = newText => {
    onSelectTemplate(newText);
    setOpenTemplates(false);
  };

  return (
    <>
      <FPIconButton
        disabled={disabled}
        onClick={toggleTemplates}
        tooltipProps={{
          title: COPIES.tooltip
        }}
      >
        <PostAddIcon color="primary" />
      </FPIconButton>

      <When condition={openTemplates}>
        <DrawerTemplates
          open={openTemplates}
          toggleTemplates={toggleTemplates}
          onSelectTemplate={handleSelectTemplate}
        />
      </When>
    </>
  );
};
